/** Strings owned by `src/manage/overview/` — "Beheer › Overzicht"
 * (PLAN-FASE3.md WP-05): the platform-staff-only KPI overview. No NPS or
 * AI-summary card — out of scope, see AdminOverviewPage.tsx. */
export const manageOverview = {
  page: {
    title: 'Resumen',
    lead: 'Cifras clave de la plataforma: ingresos, empresas y usuarios activos, y retención.',
    activeCompanies: 'Empresas activas',
    activeUsers: 'Usuarios activos',
    revenueThisMonth: 'Ingresos este mes',
    retention: 'Retención (mes a mes)',
    retentionUnavailable: 'Aún sin datos',
    retentionDetail: '{{retained}} de {{total}} empresas retenidas',
  },
} as const;
